import { getMessages } from './getMessages';
import { synchronizationMessages } from './synchronizationMessages';
import { IUpdateMessagesParams } from './types';
import { BLOB_ID } from '../../constants/blobId';
import { TThunkAction } from '../../types/redux/thunk';

/**
 * Обновление сообщений текущего чата
 */
export const updateMessages =
  ({ chatId, isOnlyCheckUpdate, trigger }: IUpdateMessagesParams): TThunkAction<Promise<void>> =>
  async (dispatch, getState) => {
    const state = getState();

    const { openedChats } = state;

    const currentChat = openedChats[chatId];

    if (chatId === BLOB_ID) {
      return;
    }

    if (isOnlyCheckUpdate) {
      dispatch(synchronizationMessages({ chatId, isOnlyCheckUpdate, trigger }));

      return;
    }

    if (currentChat && currentChat.chatMessages.length > 0) {
      dispatch(synchronizationMessages({ chatId, trigger }));

      return;
    } else {
      dispatch(getMessages(chatId, trigger));

      return;
    }

    return;
  };
